module.exports = __webpack_public_path__ + "e9d3f3c6162f37c5e644bd208e7340ea.svg";